(function () {
    'use strict';

    var module = angular.module('uwAgenda.ringfoon');
    module.filter('SearchProtocolsFilter', [SearchProtocolsFilterFn]);

    // search in protocol caption, content and category
    function SearchProtocolsFilterFn() {
        return function (items, searchValue) {
            if (typeof searchValue === 'undefined' || searchValue === null || searchValue.trim() === '') {
                // no filtering 
                return items;
            }

            var results = [];
            var searchValueLow = searchValue.toLowerCase().replace('*', '');

            items.forEach(function (item) {
                if (item.content.toLowerCase().indexOf(searchValueLow) !== -1 || item.protocolCategory.caption.toLowerCase().indexOf(searchValueLow) !== -1) {
                    results.push(item);
                }
            });
            return results;

        };
    }
})();
